import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import {ConfirmationService, SelectItem} from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import {AppSettingService} from '../../_services/app-setting.service';
import {forkJoin} from 'rxjs';
import {GarantiasIdoneas} from '../../_models/garantias-idoneas';
import {GarantiaIdoneasService} from '../../_services/garantia-idoneas.service';
import {ListaItem} from '../../_models/lista-item';
import {ListaService} from '../../_services/lista.service';

@Component( {
  selector: 'app-garantia-idoneas-editar',
  templateUrl: 'garantia-idoneas-editar.component.html'
} )

export class GarantiaIdoneasEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  garantiasIdoneas: GarantiasIdoneas;
  lisGarantiaIdonea: GarantiasIdoneas[] = [];
  formulario: FormGroup;
  submitted = false;
  idPerfilRiesgo: number;
  idPlanCargo: number;
  carTabla = true;
  rangoMontoValido = true;
  rangoInvalido = false;
  tabSeleccionado = 'DATOSPRINCIPALES';
  plazo = false;
  tasa = false;
  plazoMinimo = false;
  iva = false;
  rangoMininoValido = true;
  listasFondosGarantiasTodas: ListaItem[] = [];
  listasFondosGarantias:  SelectItem[] = [];

  constructor( private garIdoneaServices: GarantiaIdoneasService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private navServicio: NavService,
               public appSettingService: AppSettingService,
               private lisServicio: ListaService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.garIdoneaServices.obtenerPorId( params[ 'id' ] ).subscribe( paquete => {
          this.garantiasIdoneas = paquete;
          this.cargarListas();
        } );
      } else {
        this.cargarListas();
      }
    } );
  }

 async cargarListas() {
    this.listasFondosGarantiasTodas = await this.lisServicio.getMasterDetails( 'ListasFondosGarantias' ).toPromise();
    this.listasFondosGarantiasTodas.forEach( e => {
      if ( e.indicadorHabilitado) {
        this.listasFondosGarantias.push( { label: e.nombre, value: e.idLista } );
      }
    } );
   this.cargarInformacionInicial();
  }

  cargarInformacionInicial() {
    forkJoin(
      this.garIdoneaServices.listado()).
    subscribe( ( [ res1] ) => {
      this.lisGarantiaIdonea = res1;

    }, ( err1 ) => {
      this.navServicio.setMesage( 4, {
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo cargar la información. Intente nuevamente.'
      } );
    } );

    this.formulario = this.fb.group( {
      idGarantiaIdonea: [ this.garantiasIdoneas ? this.garantiasIdoneas.idGarantiaIdonea : null ],
      codigo: [ this.garantiasIdoneas ? this.garantiasIdoneas.codigo : null, [ Validators.required ] ],
      nombre: [ this.garantiasIdoneas ? this.garantiasIdoneas.nombre : null, [ Validators.required ] ],
      codigoShivam: [ this.garantiasIdoneas ? this.garantiasIdoneas.codigoShivam : null, [ Validators.required ] ],
      descripcion: [ this.garantiasIdoneas ? this.garantiasIdoneas.descripcion : null ],
      montoMinimo: [ this.garantiasIdoneas ? this.garantiasIdoneas.montoMinimo : null, [ Validators.required ] ],
      montoMaximo: [ this.garantiasIdoneas ? this.garantiasIdoneas.montoMaximo : null, [ Validators.required ] ],
      indicadorPeriodoGracia: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorPeriodoGracia : false],
      indicadorRut: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorRut : false],
      indicadorDestino: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorDestino : false],
      indicadorMunicipio: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorMunicipio : false],
      indicadorActividades: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorActividades : false],
      plazoMaximo: [ this.garantiasIdoneas ? this.garantiasIdoneas.plazoMaximo : null, [ Validators.required]],
      indicadorTasa: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorTasa : false],
      tasaCobro: [ this.garantiasIdoneas ? this.garantiasIdoneas.tasaCobro : 0],
      indicadorHabilitado: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorHabilitado : true],
      indicadorAnticipado: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorAnticipado : false],
      indicadorAnticipadoAnual: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorAnticipadoAnual : false],
      indicadorDiferido: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorDiferido : false],
      indicadorPlanPagos: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorPlanPagos : false],
      plazoMinimo: [ this.garantiasIdoneas ? this.garantiasIdoneas.plazoMinimo : null, [ Validators.required]],
      indicadorIva: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorIva : false],
      indicadorCobroPerfil: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorCobroPerfil : false],
      iva: [ this.garantiasIdoneas ? this.garantiasIdoneas.iva : 0],
      indicadorClienteNuevo: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorClienteNuevo : false],
      indicadorClienteRenovado: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorClienteRenovado : false],
      porcentajeRespaldo: [ this.garantiasIdoneas ? this.garantiasIdoneas.porcentajeRespaldo : null, [ Validators.required ]],
      indicadorRecogerCrezcamos: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorRecogerCrezcamos : false],
      indicadorNotificacionFGA: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorNotificacionFGA : false],
      indicadorGarantiaIdonea: [ this.garantiasIdoneas ? this.garantiasIdoneas.indicadorGarantiaIdonea : false],
      idFondoGarantia: [this.garantiasIdoneas ? this.garantiasIdoneas.idFondoGarantia : null,  [ Validators.required]]
    } );
    this.validacionPLazoTasa();
    this.carInformacionInicial = false;

  }



  onSubmit() {
    this.submitted = true;
    if ( !this.codExiste && this.formulario.valid && this.rangoMontoValido && this.rangoMininoValido) {
      this.guardando = true;
      const formulario = this.formulario.getRawValue();

      if(formulario.idGarantiaIdonea !== '' && formulario.idGarantiaIdonea !== null && formulario.idGarantiaIdonea !== undefined){
        if ( this.verificarNombre( formulario ) ) {
          this.navServicio.setMesage( 0, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.MSG_ERRORNOM' )
          } );
          this.guardando = false;
          this.submitted = false;
        } else {
          /** Actualizar  */
          this.garIdoneaServices.actualizar( formulario ).subscribe( plaga => {
            this.garantiasIdoneas = plaga;
            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.MSG_REGACTU' )
            } );
            this.cargarInformacionInicial();
            this.cambiarTabSeleccionado( 'TABPAQUETESEGUROS' );
          } );
        }

      } else {
        if ( this.verificarCodigoYNombre( formulario ) ) {
          this.navServicio.setMesage( 0, {
            severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.MSG_ERRORCODNOM' )
          } );
          this.guardando = false;
          this.submitted = false;
        } else {
          /** Crear */
          this.garIdoneaServices.crear( formulario ).subscribe( paquete => {
            this.garantiasIdoneas = paquete;
            this.f.idGarantiaIdonea.setValue( this.garantiasIdoneas.idGarantiaIdonea );
            this.f.codigo.setValue( this.garantiasIdoneas.codigo );
            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'GARANTIASIDONEAS.MSG_REGGUAR' )
            } );
            this.cargarInformacionInicial();
            this.cambiarTabSeleccionado( 'TABPAQUETESEGUROS' );
            // AQUI VA EL GUARDADO DEL TAB
          } );
        }
      }
    }
  }


  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: `garantia-idoneas`,
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }


  validarValor( event: any, desde: boolean ) {
    const rangoDesde = this.formulario.controls.montoMinimo.value;
    const rangoHasta = this.formulario.controls.montoMaximo.value;
    if ( desde && rangoHasta ) {
      if ( Number( rangoDesde ) >= Number( rangoHasta ) ) {
        this.rangoMontoValido = false;
      } else {
        this.rangoMontoValido = true;
      }
    } else if ( !desde && rangoDesde ) {
      if ( Number( rangoDesde ) >= Number( rangoHasta ) ) {
        this.rangoMontoValido = false;
      } else {
        this.rangoMontoValido = true;
      }
    }
  }
  validarCodigo() {
    this.codExiste = this.lisGarantiaIdonea.find( x => x.codigo === this.f.codigo.value ) ? true : false;
  }

  verificarNombre( item: GarantiasIdoneas ): boolean {
    return (this.lisGarantiaIdonea.find( x => x.nombre === item.nombre && x.idGarantiaIdonea
      !== item.idGarantiaIdonea )) ? true : false;
  }

  verificarCodigoYNombre( item: GarantiasIdoneas ): boolean {
    return (this.lisGarantiaIdonea.find( x => x.codigo === item.codigo || x.nombre === item.nombre )) ? true : false;
  }

  validacionPLazoTasa(){
    if(this.f.indicadorTasa.value){
      this.tasa = true;
      this.f.tasaCobro.setValidators( [ Validators.required ] );
      this.f.tasaCobro.updateValueAndValidity();
    }else{
      this.tasa = false;
      this.f.tasaCobro.setValue(0);
      this.f.tasaCobro.setValidators( [ ] );
      this.f.tasaCobro.updateValueAndValidity();
    }

    if(this.f.indicadorIva.value){
      this.iva = true;
      this.f.iva.setValidators( [ Validators.required ] );
      this.f.iva.updateValueAndValidity();
    } else {
      this.iva = false;
      this.f.iva.setValue(0);
      this.f.iva.setValidators( [ ] );
      this.f.iva.updateValueAndValidity();
    }

  }

  get f() {
    return this.formulario.controls;
  }

  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'DATOSPRINCIPALES';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'TABPAQUETESEGUROS';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'COBROPORPERFILRIESGO';
        break;
      }
      default: {
        break;
      }
    }
  }

  cambiarTabSeleccionado( tab: string ) {
    this.tabSeleccionado = tab;
  }

  validarPlazos() {
    let plazoMinimo = this.f.plazoMinimo.value;
    let plazoMaximo = this.f.plazoMaximo.value;
    if( Number(plazoMinimo) > Number(plazoMaximo)){
      this.rangoMininoValido = false;
    } else {
      this.rangoMininoValido = true;
    }
  }

  validarAnticipado(tipo: string) {

    if( tipo === 'Anticipado'){
      this.f.indicadorAnticipadoAnual.setValue(false);
      this.f.indicadorDiferido.setValue(false);
      this.f.indicadorAnticipado.setValue(true);
    }
    if( tipo === 'AnticipadoAnual' ){
      this.f.indicadorAnticipado.setValue(false);
      this.f.indicadorDiferido.setValue(false);
      this.f.indicadorAnticipadoAnual.setValue(true);
    }
    if( tipo === 'Diferido' ){
      this.f.indicadorAnticipado.setValue(false);
      this.f.indicadorAnticipadoAnual.setValue(false);
      this.f.indicadorDiferido.setValue(true);
    }
  }

}
